import React from "react";
import { ProgramPaymentType } from "../../../../types/dto/program";
import useEditProgramPayment from "../../hooks/useEditProgramPayment";
import EditProgramPaymentForm from "./EditProgramPaymentForm";
import useProgramSchedule from "../../../academyProgramDetail/hooks/schedule/useProgramsSchedule";
import Button from "../../../../shared/components/ui/Button";

export interface EditProgramPaymentProps {
  payment: ProgramPaymentType;
  setOpenModal: (val: boolean) => void;
  onSuccess?: () => void;
}

export default function EditProgramPayment({
  payment,
  setOpenModal,
  onSuccess,
}: EditProgramPaymentProps) {
  const { control, loading, handleSubmit, watch } = useEditProgramPayment({
    payment,
    setOpenModal,
    onSuccess,
  });
  const { programScheduleByProgram } = useProgramSchedule({
    programId: payment.program_id,
  });

  return (
    <form onSubmit={handleSubmit}>
      <EditProgramPaymentForm
        control={control}
        payment={payment}
        programScheduleByProgram={programScheduleByProgram}
        watch={watch}
      />
      <div className="mt-4 flex items-center justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={() => setOpenModal(false)}
        >
          Cancelar
        </Button>
        <Button
          primary
          className="bg-[#072082]"
          loading={loading}
          type="submit"
          variant="filled"
        >
          <i className="fa-solid fa-save" /> Guardar cambios
        </Button>
      </div>
    </form>
  );
}
